/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MedicalHistorySchema } from '../models/MedicalHistorySchema';
import type { UpdateMedicalHistorySchema } from '../models/UpdateMedicalHistorySchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MedicalHistoriesApi {
    /**
     * Get Medical History
     * Get medical history of patient. Required Permission: get_medical_history_detail
     * @returns MedicalHistorySchema OK
     * @throws ApiError
     */
    public static medicalHistoryGetMedicalHistoryGet({
        patientId,
    }: {
        patientId: string,
    }): CancelablePromise<MedicalHistorySchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/medical-histories/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
        });
    }
    /**
     * Update Medical History
     * Update medical history of patient. Required Permission: update_medical_history
     * @returns MedicalHistorySchema OK
     * @throws ApiError
     */
    public static medicalHistoryUpdateMedicalHistoryPut({
        patientId,
        requestBody,
    }: {
        patientId: string,
        requestBody: UpdateMedicalHistorySchema,
    }): CancelablePromise<MedicalHistorySchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/medical-histories/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
